// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"bd1547b3","236":"5db910b4","566":"9b39a2e7","929":"4e25cb09","944":"2604d773","998":"978e9f16"}[chunkId] + ".chunk.js";
};